import {
  queryAuth,
  saveAuth,
  modifyAuth,
  remove,
  getauth,
  getauthType,
} from '@/services/config/auth';

export default {
  namespace: 'auth',
  state: {
    data: [],
    createModalVisible: false,
    entity: undefined,
  },

  effects: {
    *queryAuth({ payload, callback }, { call, put }) {
      const response = yield call(queryAuth, payload);
      if (callback) callback(response);
      if (response.success) {
        yield put({
          type: 'success',
          payload: response.data ? response.data : [],
        });
      }
    },
    *saveAuth({ payload, callback }, { call, put }) {
      const response = yield call(saveAuth, payload);
      if (callback) callback(response);
    },
    *modifyAuth({ payload, callback }, { call, put }) {
      const response = yield call(modifyAuth, payload);
      if (callback) callback(response);
    },
    *remove({ payload, callback }, { call, put }) {
      const response = yield call(remove, payload);
      if (callback) callback(response);
    },
    *getAuthType({ payload, callback }, { call, put }) {
      const response = yield call(getauthType, payload);
      if (callback) callback(response);
    },
    *getauth({ payload, callback }, { call, put }) {
      const response = yield call(getauth, payload);
      if (callback) callback(response);
      if (response.success) {
        yield put({
          type: 'saveEntity',
          payload: response.data ? response.data : {},
        });
      }
    },
  },

  reducers: {
    success(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
    saveEntity(state, action) {
      return {
        ...state,
        entity: action.payload,
      };
    },
  },
};
